import React from "react";
import { ValueService, ValueStatus } from "@dqm/value-observer";
import {
  LastCalledController,
  LastCalledItem,
} from "@dqm/react-last-called-component";
import { LastCalled } from "./LastCalled";

interface Props {
  valueService: ValueService;
}

export const Controller: React.FC<Props> = ({ valueService }) => {
  return (
    <LastCalledController valueService={valueService}>
      {({
        items,
        status,
      }: {
        items: LastCalledItem[];
        status: ValueStatus;
      }) => {
        return status === ValueStatus.Fault ? null : (
          <LastCalled items={items} />
        );
      }}
    </LastCalledController>
  );
};
